import { TeamColor } from '@algoan/dashboard/model';

export const TeamIcon: React.FC<{ color?: TeamColor }> = ({ color }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <circle cx="6.9" cy="6.9" r="6.5" fill="white" />
      <path
        d="M7 0C3.1 0 0 3.1 0 7 0 10.9 3.1 14 7 14 10.9 14 14 10.9 14 7 14 3.1 10.9 0 7 0ZM9.5 4.4C10.3 4.4 10.9 5 10.9 5.8 10.9 6.5 10.3 7.1 9.5 7.1 8.8 7.1 8.2 6.5 8.2 5.8 8.2 5 8.8 4.4 9.5 4.4ZM5.3 3.3C6.2 3.3 7 4.1 7 5 7 5.9 6.2 6.6 5.3 6.6 4.4 6.6 3.7 5.9 3.7 5 3.7 4.1 4.4 3.3 5.3 3.3ZM5.3 9.7V12.3C3.6 11.8 2.3 10.5 1.7 8.9 2.5 8.1 4.3 7.7 5.3 7.7 5.7 7.7 6.2 7.7 6.7 7.8 5.5 8.5 5.3 9.3 5.3 9.7ZM7 12.6C6.8 12.6 6.6 12.6 6.4 12.6V9.7C6.4 8.7 8.5 8.2 9.5 8.2 10.3 8.2 11.6 8.5 12.2 9 11.4 11.1 9.4 12.6 7 12.6Z"
        fill={mapColorEnumToHexColor(color)}
      />
    </svg>
  );
};

const mapColorEnumToHexColor = (color?: TeamColor): string => {
  switch (color) {
    case TeamColor.RED:
      return '#F95A3E';
    case TeamColor.BLUE:
      return '#1F8EF1';
    case TeamColor.GREEN:
      return '#5BB514';
    case TeamColor.PURPLE:
      return '#DE49F2';
    case TeamColor.ORANGE:
      return '#F4873A';
    case TeamColor.YELLOW:
      return '#EAE242';
    case TeamColor.MUSTARD_YELLOW:
      return '#F4CA5B';
    case TeamColor.PINK:
      return '#FB4395';
    case TeamColor.TURQUOISE:
      return '#11B2A9';
    case TeamColor.VIOLET:
      return '#7A6EEE';
    default:
      return 'grey';
  }
};
